module.exports = __WEBPACK_EXTERNAL_MODULE__babylonjs_core_ShadersWGSL_ShadersInclude_logDepthDeclaration__;